<div class="chart-preferences-container">

  <!-- Formly Form -->
  <form [formGroup]="form" (ngSubmit)="preferencesChange.emit(model)">

    <formly-form [form]="form" [fields]="fields" [model]="model">
    </formly-form>
 <!-- <div class="form-actions-primary">
      <button mat-flat-button color="primary" type="submit" (click)="onSubmit()">
        Apply
      </button>

      <button mat-stroked-button color="warn" type="button" (click)="onCancel()">
        Cancel
      </button>
    </div> -->
    <!-- Action buttons -->
    <!-- <div class="actions">
      <button mat-flat-button color="primary" type="button" (click)="resetToDefaults()">
        Reset to Defaults
      </button>

      <button mat-flat-button color="accent" type="button" (click)="exportPreferences()">
        Export Preferences
      </button>

      <label class="import-btn">
        <input type="file" accept=".json" (change)="importPreferences($event)">
        <span>Import Preferences</span>
      </label>
    </div> -->
    
  </form>

</div>
